import { useTranslation } from 'react-i18next'
import { useExchangeRates } from '@components/ExchangeRatesProvider'
import { currenciesList } from '@velasca/constants'
import { formatCurrencies } from '@velasca/utils/format-currencies'
import { $settings } from '@velasca/utils/globals'
import * as S from './SwitchCurrency.styles'

export interface SwitchCurrencyProps {
  closeSectionHandler: () => void
  currencies: string[]
}

export const SwitchCurrency = ({
  currencies,
  closeSectionHandler,
}: SwitchCurrencyProps) => {
  const { t } = useTranslation('global')
  const { setCurrency } = useExchangeRates()
  const currenciesData = formatCurrencies(currenciesList, $settings.language)

  return (
    <S.Container>
      <S.CurrencyList>
        <S.Subtitle>
          {t('switchCurrencyMobileLabel')}
          {/* // TODO: due to the EEA, aria labels and alt has been added in en
          only. Define how to handle this in the future for a EEA assessment and
          complete implementation */}
          <S.CloseButton aria-label="Close" onClick={closeSectionHandler}>
            <S.CloseIcon />
          </S.CloseButton>
        </S.Subtitle>
        {currencies.map((currency) => {
          const currencyItemData = currenciesData.find(
            (c) => c.code === currency,
          )

          return (
            <S.CurrencyItem
              key={currency}
              onClick={() => {
                setCurrency(currency)
                closeSectionHandler && closeSectionHandler()
              }}
            >
              {currencyItemData ? (
                <>
                  <S.CurrencyFlag
                    className={`flag-icon-${currencyItemData.flag}`}
                  />
                  <span>
                    {currencyItemData.label} (
                    <strong>{currencyItemData.code}</strong>)
                  </span>
                </>
              ) : (
                <span>{currency}</span>
              )}
            </S.CurrencyItem>
          )
        })}
      </S.CurrencyList>
    </S.Container>
  )
}
